import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { GrowerDTO } from "../dtos/GrowerDTO";
import { STALE_TIME_LONG } from "../queries/query.constants";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { computed } from "vue";
const GROWERS_STALE_TIME = STALE_TIME_LONG;
// Growers for the current customer
export function useGrowers() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["growers"],
        queryFn: async () => (await seedgreenAPI.get("v2/Grower")).data,
        staleTime: GROWERS_STALE_TIME,
        select: (data) => data?.map((grower) => new GrowerDTO(grower)) ??
            [],
    });
    return {
        growers: query.data,
        growersById: computed(() => _.keyBy(query.data.value, "id")),
        ...query,
    };
}
